import React from 'react';

import PropTypes from 'prop-types';
import FaClose from 'react-icons/lib/fa/close';

function ClearIcon(props) {
    const {
        className,
        'data-id': dataId,
        onClick,
        ...otherProps
    } = props;

    return (
        <span
            className={className}
            data-id={dataId}
            onClick={onClick}
        >
            <FaClose {...otherProps} />
        </span>
    );
}

ClearIcon.propTypes = {
    className: PropTypes.string,
    'data-id': PropTypes.string,
    onClick: PropTypes.func,
};

ClearIcon.defaultProps = {
    className: '',
    'data-id': '',
    onClick() {},
};

export default ClearIcon;
